import React, { ReactElement, useEffect } from 'react'
import Divider from '../../Divider'
import VotesClaimsOverview from './VotesClaimsOverview'
import { ArtData } from '@/database/art'

const VotesClaimsPanel = ({ artData, tabName }: { artData: ArtData | undefined; tabName: string }): ReactElement => {
    useEffect(() => {
        window.location.hash = `#nft-${artData?.tokenId + tabName}#votesclaims`
    }, [artData])

    return (
        <div className="panel">
            <Divider />
            <VotesClaimsOverview artData={artData} />
        </div>
    )
}

export default VotesClaimsPanel
